import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './OverlayCard.scss';

const getHltsData = hltsData =>
  hltsData.length > 0 && (
    <ul className={s.synopsisHglts}> {hltsData.map(el => <li>{el}</li>)}</ul>
  );

const CardComponent = ({
  cardsData,
  dataLoading,
  isWapView,
  synopsis,
  hlts,
}) => {
  if (dataLoading) {
    return (
      <img
        className={s.containerImg}
        src="https://static.toiimg.com/photo/89633620.cms"
        alt="placeholder_img"
        width="300"
        height="90"
      />
    );
  }
  return (
    <>
      {isWapView &&
        (synopsis || (Array.isArray(hlts) && hlts?.length > 0)) && (
          <div className={s.synopsiscard}>{synopsis || getHltsData(hlts)}</div>
        )}

      {Array.isArray(cardsData) &&
        cardsData.length > 0 &&
        Object.keys(cardsData[0]).map(card => (
          <div key={cardsData[0][card]} className={s.cards}>
            {cardsData[0][card].render_as === 'image'
              ? cardsData[0][card].screenshot_url && (
                  <img
                    className={s.containerImg}
                    src={cardsData[0][card].screenshot_url}
                    alt="card_image"
                    width="300"
                    height="90"
                  />
                )
              : cardsData[0][card].iframe && (
                  <div
                    /* eslint-disable react/no-danger */
                    dangerouslySetInnerHTML={{
                      __html: cardsData[0][card].iframe,
                    }}
                  />
                )}
          </div>
        ))}
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  cardsData: state.toiplusprimeshow.cardsData,
  synopsis: state?.toiplusprimeshow?.data[ownProps.msid]?.syn,
  dataLoading: state.toiplusprimeshow.dataLoading,
  hlts: state.toiplusprimeshow.data[ownProps.msid]?.hlts,
});

CardComponent.propTypes = {
  cardsData: PropTypes.arrayOf(PropTypes.object),
  dataLoading: PropTypes.bool,
  isWapView: PropTypes.bool,
  synopsis: PropTypes.string,
  hlts: PropTypes.arrayOf(PropTypes.string),
};

CardComponent.defaultProps = {
  cardsData: [],
  dataLoading: true,
  isWapView: true,
  synopsis: '',
  hlts: [],
};

export default connect(mapStateToProps)(CardComponent);
